import { render, staticRenderFns } from "./ElectronicContractTemplateConfig.vue?vue&type=template&id=5fd74b86&scoped=true"
import script from "./ElectronicContractTemplateConfig.vue?vue&type=script&lang=js"
export * from "./ElectronicContractTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./ElectronicContractTemplateConfig.vue?vue&type=style&index=0&id=5fd74b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd74b86",
  null
  
)

export default component.exports